import PropTypes from "prop-types";
import React from "react";
import { page as pageIndex } from "../../globals";
import MultiSelect from "../FormComponents/MultiSelect/MultiSelect";
import STSComponent from "../STSComponent/STSComponent";

class StateProgressBlock extends STSComponent{
  constructor(props) {
    super(props);
    this.resetToDefault = this.resetToDefault.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    return (
      JSON.stringify(nextProps.values) !== JSON.stringify(this.props.values) ||
      nextProps.field !== this.props.field
    );
  }

  setCounter = (type, newArr) => {
    let resultedNumber = 0;
    if (newArr.length === 0) {
      return resultedNumber;
    }
    if (type === "state") {
      resultedNumber = resultedNumber + newArr.length;
    } else {
      const localLength = newArr.filter((item) => item.length !== 2);
      resultedNumber = localLength.length;
    }
    return resultedNumber;
  };

  getPlaceholder = (blockName, arr) => {
    const { values, page } = this.props;
    const newArr = values.selected;
    let staticLocalNumber = 0;
    let staticStateNumber = arr.length;
    let blName;
    for (let i = 0; i < arr.length; i++) {
      const local = arr[i].locality !== undefined ? arr[i].locality.length : 0;
      staticLocalNumber = staticLocalNumber + local;
    }
    const option = values.selected.length === 0;
    switch (blockName) {
      case "progress":
        return option ? "Any Progress" : "Select Progress";
      case "states":
        return option ? "All States" : "Select States";
      case "legisStates":
      case "regsStatesRegister":
      case "regsStatesAgency":
        blName = newArr.length === 1 ? "State" : "States";
        const stateNum = this.setCounter("state", newArr);
        return newArr.length === 0
          ? `Select ${blName}`
          : stateNum === staticStateNumber
          ? `All ${blName}`
          : `${stateNum} ${blName} Selected`;
      case "locality":
        blName = newArr.length === 1 ? "Locality" : "Localities";
        if (page === pageIndex.cmd) {
          const localityNum = this.setCounter("locality", newArr);
          return newArr.length === 0
            ? `Select ${blName}`
            : localityNum === staticLocalNumber
            ? `All ${blName}`
            : `${localityNum} ${blName} Selected`;
        }
        return option ? `All ${blName}` : `Select ${blName}`;
      default:
        break;
    }
  };

  resetToDefault = () => {
    const { updateData, page, field } = this.props;
    // TODO: when client is opened reset should be to last saved state. now only for default (none)
    updateData({ page, field }, "ch_uncheckall");
  };

  render() {
    const { values, updateData, page, field, title, fieldData } = this.props;
    const className =
      field === "progress" ? "form-element" : "form-element states-btn";
    const childrenClass =
      field === "progress"
        ? "full-name"
        : field === "locality"
        ? "shortcut-localities"
        : "shortcut";
    const placeHolder = this.getPlaceholder(field, fieldData);
    const titleLine =
      page === pageIndex.cmd ? (
        <div className="d-flex justify-content-between">
          <span className="form-text-subtitle">{title}</span>
          <span
            className="form-text-subtitle green-title"
            onClick={this.resetToDefault}
          >
            Reset
          </span>
        </div>
      ) : (
        <span className="form-text-subtitle">{title}</span>
      );
    return (
      <div className={className}>
        {titleLine}
        <MultiSelect
          values={values}
          childrenClassName={childrenClass}
          inputPlaceholder={placeHolder}
          fieldData={fieldData}
          location={{ page, field }}
          updateData={updateData}
          hideBoxes={page === pageIndex.cmd}
        />
      </div>
    );
  }
  static propTypes = {
    page: PropTypes.string,
    field: PropTypes.string,
    title: PropTypes.string,
    values: PropTypes.object.isRequired,
    updateData: PropTypes.func,
    fieldData: PropTypes.array,
  };
}

export default StateProgressBlock;



// WEBPACK FOOTER //
// ./src/components/StatesProgress/StatesProgress.js